import React from 'react';
import { product } from './content/site';
import { CartProvider } from './components/ShoppingCart';
import { StoreHeader, StoreFooter } from './components/StoreChrome';
import CartPage from './CartPage';
import Product from './components/Product';
import Newsletter from './components/Newsletter';
import Preorders from './Preorders';
import Gym from './Gym';
import AdminApp from './AdminApp';
import GymPortal from './GymPortal';
export default function App({ pathname = typeof window !== 'undefined' ? window.location.pathname : '/' }) {
  if (pathname==='/admin' || pathname.startsWith('/admin/')) return <AdminApp pathname={pathname}/>;
  if (pathname.replace(/\/$/, '') === '/gym') return <Gym />;
  if (pathname.replace(/\/$/, '') === '/gym-portal') return <GymPortal />;
  if (pathname.replace(/\/$/, '') === '/cart') return <CartPage />;
  if (pathname.replace(/\/$/, '') === '/preorders') return <Preorders />;
  return (
    <CartProvider><>
      <a className="skip-link" href="#main">Skip to content</a>
      <StoreHeader />
      <main id="main">
        <section className="hero" aria-labelledby="hero-heading">
          <div className="hero-copy">
            <p className="eyebrow"><span className="red-dot" /> HIKARI FIGHT GEAR</p>
            <h1 id="hero-heading">Focus on<br />what <em>matters.</em></h1>
            <p className="intro">Quality martial arts gear at an affordable price. For gyms. For practitioners. For time on the mat.</p>
            <a className="button" href="#gi">Find your gi <span aria-hidden="true">↗</span></a>
            <div className="hero-note"><span className="rule" /> LESS DISTRACTION. MORE TRAINING.</div>
          </div>
          <div className="hero-photo">
            <img src="/img/cjj40.png" width="1800" height="1200" alt="Two Brazilian jiu-jitsu practitioners training in black Hikari gis" fetchpriority="high" />
            <div className="photo-caption"><span>ON THE MAT</span><span>HIKARI / FIGHT GEAR</span></div>
          </div>
        </section>
        <div className="spec-strip"><span>100% PEARL WEAVE</span><span>BLACK / RED</span><span>SIZES A1–A4</span><a href="#gi">MEET THE FLAGSHIP ↓</a></div>
        <Product product={product} />
        <Newsletter />
      </main>
      <StoreFooter />
    </></CartProvider>
  );
}
